module.exports = __webpack_public_path__ + "img/Digi_entwurf_4.d2f0b527.png";